module.exports = __webpack_public_path__ + "img/detalhe.f3034c5b.png";